module.exports = __webpack_public_path__ + "img/wein-natur-desktop.2268e4ae.jpg";